<template>
  <div class="nfh">
    <div
      class="nfh_rank"
      v-if="index + 1 === 1"
      @click.stop="jumpToNfh(nfh.columnId)"
    >
      <i class="gold medal"></i>
    </div>
    <div
      class="nfh_rank"
      v-if="index + 1 === 2"
      @click.stop="jumpToNfh(nfh.columnId)"
    >
      <i class="silver medal"></i>
    </div>
    <div
      class="nfh_rank"
      v-if="index + 1 === 3"
      @click.stop="jumpToNfh(nfh.columnId)"
    >
      <i class="copper medal"></i>
    </div>
    <div
      class="nfh_rank"
      v-if="index + 1 > 3"
      @click.stop="jumpToNfh(nfh.columnId)"
    >
      {{ index + 1 }}
    </div>
    <div class="nfh_wrap">
      <div class="nfh_img" @click.stop="jumpToNfh(nfh.columnId)">
        <img :src="nfh.columnIcon || defaultImg" class="nfh_img_icon" />
        <img :src="goldIcon" class="nfh_img_gold" v-if="nfh.isGoldColumn" />
      </div>
      <div class="nfh_content" @click.stop="jumpToNfh(nfh.columnId)">
        <div class="nfh_title">{{ nfh.columnName }}</div>
        <div class="nfh_num">
          <i class="fire_icon"></i>{{ nfh.popularVal + popularVal }}人气
        </div>
      </div>
      <div class="nfh_status" v-if="!isNfPlus" @click.stop="showSupport">
        <span class="call_btn">{{
          isLatest ? (hasHit ? "再次打榜" : "打榜") : "+订阅"
        }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { staticUrl, nanfangIfUrl } from "@/js/url";
import defaultImg from "@/img/nfh_logo.png";
import goldIcon from "@/img/nfhGoldIcon1.png";
import { newOpenApp } from "@/js/newOpenApp";
import { wxAuth } from "@/js/wx";
import platform from "@/js/platform";
export default {
  props: {
    nfh: {},
    index: 0,
    isLatest: true, //当前是否是最新一期
    hitList: {
      required: true,
      type: Array,
    },
    cityRankInfo: {},
  },
  data() {
    return {
      defaultImg,
      goldIcon,
      hasHit: false,
      popularVal: 0,
      isNfPlus: platform.isNfPlus
    };
  },
  created() {
    this.checkHasHit();
  },
  watch: {
    hitList() {
      this.checkHasHit();
    },
  },
  methods: {
    checkHasHit() {
      if (this.hitList.indexOf(this.nfh.columnId + "") > -1) {
        this.hasHit = true;
      }
    },
    showSupport() {
      function isWeixinBrowser() {
        let ua = navigator.userAgent.toLowerCase();
        return /micromessenger/.test(ua);
      }
      if (this.isLatest) {
        if (this.hasHit) {
          this.myOpenApp(this.nfh.columnId);
        } else {
          if (isWeixinBrowser()) {
            wxAuth(this.hit);
          } else {
            this.myOpenApp(this.nfh.columnId);
          }
        }
      } else {
        this.myOpenApp(this.nfh.columnId);
      }
    },
    hit(uuid) {
      let self = this;
      this.$emit("getUuid", uuid);
      $.ajax({
        url: `${nanfangIfUrl}/nfh/popular/hit`,
        type: "POST",
        dataType: "json",
        data: {
          columnId: self.nfh.columnId,
          uuid: uuid,
        },
        success: (res) => {
          if (res.code === 200) {
            self.popularVal = 1;
            self.$emit("popSupport", { bool: true, nfh: self.nfh });
            self.hasHit = true;
          } else if (res.code === 400) {
            self.hasHit = true;
            self.$emit("popSupport", {
              bool: true,
              nfh: self.nfh,
              tipsMsg: "每天只能打榜一次",
            });
          } else if (res.code === 403) {
            self.$emit("popSupport", {
              bool: true,
              nfh: self.nfh,
              tipsMsg: "打榜失败，请重试",
            });
            window.localStorage.removeItem("wxUserUuid");
          }
        },
      });
    },
    jumpToNfh(columnId) {
      //跳转南方号分享页
      window.location.href = `${staticUrl}/nfh/shareNFNum/index.html?nfhId=${columnId}`;
    },
    myOpenApp(columnId) {
      //跳转客户端榜单页面
      console.log("唤醒客户端");
      // 订阅
      newOpenApp(columnId, "cityRank", false, this.cityRankInfo, 24);
    },
  },
};
</script>
<style lang="less">
@import url("../less/mixin.less");
.nfh {
  display: flex;
  flex-direction: row;
  padding-right: 0.2rem;
  .nfh_rank {
    width: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.26rem;
    color: #999;
    font-weight: bold;
    .medal {
      display: inline-block;
      width: 0.4rem;
      height: 0.6rem;
    }
    .gold {
      .bg-image("../img/gold_icon");
    }
    .silver {
      .bg-image("../img/silver_icon");
    }
    .copper {
      .bg-image("../img/copper_icon");
    }
  }
  .nfh_wrap {
    flex: 1;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #eee;
    padding: 0.3rem 0 0.3rem 0;
    width: 3rem;
    .nfh_img {
      position: relative;
      width: 1rem;
      height: 1rem;
      margin-right: 0.2rem;
      > .nfh_img_icon {
        width: 100%;
        height: 100%;
        border: 1px solid #eee;
        border-radius: 50%;
      }

      > .nfh_img_gold {
        position: absolute;
        bottom: -0.05rem;
        right: -0.05rem;
        width: 0.36rem;
        height: 0.36rem;
      }
    }
    .nfh_content {
      .nfh_title {
        font-size: 0.34rem;
        color: #333;
        max-width: 3.8rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 12px;
      }
      .nfh_num {
        font-size: 0.22rem;
        color: #999;
        .fire_icon {
          display: inline-block;
          width: 0.2rem;
          height: 0.24rem;
          .bg-image("../img/red_hot_icon");
          margin-right: 5px;
        }
      }
    }
    .nfh_status {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .call_btn {
        padding: 0 0.2rem;
        border: 1px solid #f64e45;
        border-radius: 2.5px;
        color: #f64e45;
        white-space: nowrap;
      }
    }
    .nfh_content {
      flex: 1;
      width: 1.94rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/popularItem.vue